// @ts-ignore
import * as dynamic from './dynamic/i18n.ru';
import { ITranslations } from './types';

const i18n: ITranslations = {};
i18n['agencies'] = {};
i18n['agencies']['budget-from'] = function(params) { return "от " + params["budget"] + " руб." };
i18n['agencies']['budgets'] = "Бюджет рекламной кампании";
i18n['agencies']['certificates'] = "Сервис";
i18n['agencies']['cities'] = "Город";
i18n['agencies']['city'] = "Город";
i18n['agencies']['countries'] = "Страна";
i18n['agencies']['country'] = "Страна";
i18n['agencies']['search'] = "Поиск";
i18n['agencies']['service'] = "Сервис";
i18n['agencies']['specify'] = "Уточнить поиск";
i18n['agencies']['text'] = "На этой странице представлены рекламные агентства из вашего региона. Выбрать другой регион поиска можно с помощью фильтра ниже. В России, Украине и Беларуси вы можете найти сертифицированные агентства Яндекса.";
i18n['agencies']['title'] = "Сертифицированные агентства";
i18n['agency'] = {};
i18n['agency']['address'] = "Адрес";
i18n['agency']['allagencies'] = "Все агентства";
i18n['agency']['certificate_plate'] = "https://avatars.mds.yandex.net/get-adv/121152/2a00000165e8410a65a9bba14ae6c34a1923/orig";
i18n['agency']['certificate_title'] = "Сертифицированное агенство Яндекса";
i18n['agency']['certificates'] = "Сертификации";
i18n['agency']['certified-yandex-agency'] = "Сертифицированное агентство Яндекса";
i18n['agency']['email'] = "Эл. почта";
i18n['agency']['feedback'] = "Связаться";
i18n['agency']['form.button'] = "Отправить";
i18n['agency']['form.email'] = "Ваш email";
i18n['agency']['form.message'] = "Сообщение";
i18n['agency']['form.name'] = "Ваше имя";
i18n['agency']['modal.title'] = "Связаться с агентством";
i18n['agency']['next'] = "Следующее";
i18n['agency']['phone'] = "Телефон";
i18n['agency']['prev'] = "Предыдущее";
i18n['agency']['readmore'] = "Подробнее";
i18n['agency']['site'] = "Сайт";
i18n['agency']['type.dialogs'] = "Яндекс.Диалоги";
i18n['agency']['type.direct'] = "Яндекс.Директ";
i18n['agency']['type.market'] = "Яндекс.Маркет";
i18n['agency']['type.metrika'] = "Яндекс.Метрика";
i18n['agency']['type.toloka'] = "Яндекс.Толока";
i18n['common'] = {};
i18n['common']['addUser'] = "Изменить логин";
i18n['common']['amp-breadcrumb'] = "Новости";
i18n['common']['and'] = "и";
i18n['common']['comdi.not-supported'] = "В вашей версии браузера трансляция недоступна. Попробуйте <a href=\"https://browser.yandex.ru\" target=\"_blank\">Яндекс.Браузер</a>";
i18n['common']['conditions'] = "Условия";
i18n['common']['days'] = "Дни";
i18n['common']['facebook'] = "Фейсбук";
i18n['common']['habrahabr'] = "Хабрахабр";
i18n['common']['hours'] = "Часы";
i18n['common']['instagram'] = "Инстаграм";
i18n['common']['linkedin'] = "LinkedIn";
i18n['common']['loading-error'] = "Ошибка загрузки";
i18n['common']['login'] = "Войти";
i18n['common']['logout'] = "Выйти";
i18n['common']['media.cases'] = "Кейсы";
i18n['common']['media.courses'] = "Обучение";
i18n['common']['media.stories'] = "Истории успеха";
i18n['common']['minutes'] = "Минуты";
i18n['common']['more.button.error'] = "Что-то пошло не так. Пожалуйста, попробуйте позже.";
i18n['common']['more.button.text'] = "Показать еще";
i18n['common']['news-is-not-available'] = "Раздел новостей сейчас недоступен.<br /> Пожалуйста, попробуйте позже.";
i18n['common']['no'] = "Нет";
i18n['common']['oldbrowser.close'] = "Закрыть";
i18n['common']['oldbrowser.download'] = "Обновить браузер";
i18n['common']['oldbrowser.text'] = "Работоспособность сервиса не гарантируется";
i18n['common']['online.edu'] = "Онлайн-обучение";
i18n['common']['project.name'] = "Рекламные технологии";
i18n['common']['rss'] = "RSS";
i18n['common']['search.all_pages'] = "Все страницы";
i18n['common']['seconds'] = "Секунды";
i18n['common']['swipe.slideInfo'] = "из";
i18n['common']['twitter'] = "Твиттер";
i18n['common']['vkontakte'] = "ВКонтакте";
i18n['common']['yes'] = "Да";
i18n['common']['youtube'] = "YouTube";
i18n['common']['сancel'] = "Отмена";
i18n['dashboard'] = {};
i18n['dashboard']['cat.1239063375'] = "Электроника";
i18n['dashboard']['cat.1412163005'] = "Авто: услуги";
i18n['dashboard']['cat.1473509328'] = "Образование и трудоустройство";
i18n['dashboard']['cat.1582506554'] = "Одежда и обувь";
i18n['dashboard']['cat.1644710081'] = "Дом и сад";
i18n['dashboard']['cat.200304283'] = "Авто: товары";
i18n['dashboard']['cat.2107020788'] = "Другое";
i18n['dashboard']['cat.2222683737'] = "Медицина";
i18n['dashboard']['cat.2408536966'] = "Бытовые услуги и общепит";
i18n['dashboard']['cat.2455984605'] = "UNKNOWN";
i18n['dashboard']['cat.2473087795'] = "Юридические услуги и консалтинг";
i18n['dashboard']['cat.2587886448'] = "Строительство и ремонт: товары";
i18n['dashboard']['cat.3119845291'] = "Подарки";
i18n['dashboard']['cat.3315302486'] = "Строительство и ремонт: услуги";
i18n['dashboard']['cat.3566538395'] = "FMCG";
i18n['dashboard']['cat.3737414780'] = "Бытовая техника";
i18n['dashboard']['cat.3989916053'] = "Недвижимость";
i18n['dashboard']['cat.4170831985'] = "Путешествия и туризм";
i18n['dashboard']['cat.4194169969'] = "B2B";
i18n['dashboard']['cat.491274388'] = "Развлечения и СМИ";
i18n['dashboard']['cat.518209040'] = "Спортивные товары и услуги";
i18n['dashboard']['cat.570002290'] = "FOR_TOTAL_COUNTER";
i18n['dashboard']['cat.676268400'] = "IT и Телеком";
i18n['dashboard']['cat.80967844'] = "Финансы и страхование";
i18n['dashboard']['cat.auto'] = "Авто";
i18n['dashboard']['cat.consulting'] = "Консалтинг";
i18n['dashboard']['cat.finance'] = "Финансы";
i18n['dashboard']['cat.realty'] = "Недвижимость";
i18n['dashboard']['cat.retail'] = "Ретейл";
i18n['dashboard']['comparison.add'] = "Добавить к сравнению";
i18n['dashboard']['comparison.delete'] = "Удалить сравнение";
i18n['dashboard']['error.modal'] = "По выбранным параметрам данные недоступны или находятся в обработке";
i18n['dashboard']['error.widget'] = "Не удалось отобразить данные, попробуйте позже.";
i18n['dashboard']['platform.desktop'] = "ПК";
i18n['dashboard']['platform.mobile'] = "Мобильные";
i18n['dashboard']['region.1'] = "Москва и Московская область";
i18n['dashboard']['region.10174'] = "Санкт-Петербург и Ленинградская область";
i18n['dashboard']['region.102444'] = "Северо-Кавказский ФО";
i18n['dashboard']['region.17'] = "Северо-Западный ФО (без Санкт-Петербурга и ЛО)";
i18n['dashboard']['region.17,-2'] = "Северо-Западный ФО";
i18n['dashboard']['region.225'] = "Россия";
i18n['dashboard']['region.26'] = "Южный ФО";
i18n['dashboard']['region.3'] = "Центральный ФО (без Москвы и МО)";
i18n['dashboard']['region.3,-213'] = "Центральный ФО ";
i18n['dashboard']['region.40'] = "Приволжский ФО";
i18n['dashboard']['region.52'] = "Уральский ФО";
i18n['dashboard']['region.59'] = "Сибирский ФО";
i18n['dashboard']['region.73'] = "Дальневосточный ФО";
i18n['dashboard']['title.add'] = "Добавить сравнение";
i18n['dashboard']['title.remove'] = "Убрать сравнение";
i18n['dashboard']['type.interest'] = "Изменение интереса, неделя к неделе";
i18n['dashboard']['type.network'] = "РСЯ. Изменение CPC, неделя к неделе";
i18n['dashboard']['type.search'] = "Поиск. Изменение CPC, неделя к неделе";
i18n['dashboard']['widget.type.interest'] = "скорость изменения интереса";
i18n['edu'] = {};
i18n['edu']['answer'] = "Ответить";
i18n['edu']['city'] = "Город";
i18n['edu']['company'] = "Компания";
i18n['edu']['contact'] = "Связаться";
i18n['edu']['country'] = "Страна";
i18n['edu']['events'] = "Мероприятия";
i18n['edu']['expert.readyToComeInYourCity'] = "Готов приехать в ваш город";
i18n['edu']['expert.readyToTrips'] = "Готов к командировкам";
i18n['edu']['leave.feedback'] = "Оставить отзыв";
i18n['edu']['lesson-content'] = "В этом уроке вы узнаете";
i18n['edu']['lessons.list'] = "Список уроков";
i18n['edu']['months'] = "Месяц";
i18n['edu']['next.lesson'] = "Следующий урок";
i18n['edu']['online'] = "Онлайн";
i18n['edu']['prev.lesson'] = "Предыдущий урок";
i18n['edu']['reviews'] = "Отзывы клиентов";
i18n['edu']['specialization'] = "Специализация";
i18n['edu']['starts.at'] = "начало в";
i18n['edu']['themes'] = "Все тематики";
i18n['edu']['user.certificate'] = function(params) { return "Сертификат пользователя " + params["lastname"] };
i18n['edu']['workFormat'] = "Формат работы";
i18n['file-upload'] = {};
i18n['file-upload']['files-limit-error'] = function(params) { return "Можно прикрепить не более " + params["count"] + " " + dynamic.plural_adv({"count": params["count"], "one": "файла", "some": "файлов", "many": "файлов", "none": "файлов"}) };
i18n['file-upload']['limit-hint'] = function(params) { return "Максимум " + params["count"] + " " + dynamic.plural_adv({"count": params["count"], "one": "файл", "some": "файла", "many": "файлов", "none": "файлов"}) + " " + dynamic.toggle({"condition": params["multiple"], "true": "общим", "false": ""}) + " размером до " + params["size"] + " МБ" };
i18n['file-upload']['size-limit-error'] = "Размер загружаемых файлов превышает допустимый размер";
i18n['file-upload']['upload-text'] = "Загрузить";
i18n['filters'] = {};
i18n['filters']['clear'] = "Очистить фильтры";
i18n['forms'] = {};
i18n['forms']['400_SMF'] = "Не удалось подписать на рассылку";
i18n['forms']['400_SNA'] = function(params) { return "Не удалось подписать на рассылки: " + params["param"] };
i18n['forms']['400_SNS'] = "Пожалуйста, укажите минимум одну рассылку";
i18n['forms']['403_CCI'] = "указан неверный код с картинки";
i18n['forms']['403_ICT'] = "Произошла ошибка. Пожалуйста, попробуйте позже.";
i18n['forms']['503_MNS'] = "Не получилось отправить сообщение. Пожалуйста, попробуйте написать еще раз.";
i18n['forms']['captcha'] = "Введите код с картинки:";
i18n['forms']['captcha.change'] = "Другой код";
i18n['forms']['emptyValue'] = "–";
i18n['forms']['error'] = "Что-то пошло не так. Пожалуйста, попробуйте позже.";
i18n['forms']['error.server'] = "Что-то пошло не так. Пожалуйста, попробуйте еще раз.";
i18n['forms']['form'] = "Форма";
i18n['forms']['label.comment'] = "Комментарий";
i18n['forms']['label.email'] = "Ваш email";
i18n['forms']['label.login'] = "Логин в Яндексе";
i18n['forms']['label.name'] = "Ваше имя";
i18n['forms']['label.phone'] = "Телефон";
i18n['forms']['label.region'] = "Регион";
i18n['forms']['label.site'] = "Сайт";
i18n['forms']['subscribed.multi.text'] = "Проверьте свой почтовый ящик. Если вы подписались на несколько тем, подтвердить подписку нужно будет по каждой из них.";
i18n['forms']['subscribed.multi.title'] = "Спасибо!";
i18n['forms']['subscribed.single.text'] = "Проверьте свой почтовый ящик.";
i18n['forms']['subscribed.single.title'] = "Спасибо!";
i18n['forms']['subscription.button'] = "Подписаться";
i18n['forms']['subscription.button.register'] = "Зарегистрироваться";
i18n['forms']['success.def.text'] = "Пожалуйста, не дублируйте свой вопрос. Наши специалисты обязательно вам ответят.";
i18n['forms']['success.def.title'] = "Ваше сообщение отправлено";
i18n['header'] = {};
i18n['header']['service.adv'] = "Рекламодателям";
i18n['header']['service.blog'] = "Блог";
i18n['header']['service.company'] = "Компания";
i18n['header']['service.edu'] = "Обучение";
i18n['header']['service.events'] = "События";
i18n['header']['service.science'] = "Наука";
i18n['header']['service.tech'] = "Разработчикам";
i18n['header']['service.vacancies'] = "Вакансии";
i18n['materials'] = {};
i18n['materials']['error'] = "Не удалось загрузить материалы. Попробуйте позже";
i18n['menu'] = {};
i18n['menu']['agency'] = "Агентства в вашем регионе";
i18n['menu']['backward'] = "Назад";
i18n['menu']['menu'] = "Меню";
i18n['menu']['offices'] = "Офисы продаж";
i18n['menu']['order'] = "Заказать рекламу";
i18n['menu']['support'] = "Служба поддержки";
i18n['months'] = {};
i18n['months']['g1'] = "Января";
i18n['months']['g10'] = "Октября";
i18n['months']['g11'] = "Ноября";
i18n['months']['g12'] = "Декабря";
i18n['months']['g2'] = "Февраля";
i18n['months']['g3'] = "Марта";
i18n['months']['g4'] = "Апреля";
i18n['months']['g5'] = "Мая";
i18n['months']['g6'] = "Июня";
i18n['months']['g7'] = "Июля";
i18n['months']['g8'] = "Августа";
i18n['months']['g9'] = "Сентября";
i18n['months']['n1'] = "Январь";
i18n['months']['n10'] = "Октябрь";
i18n['months']['n11'] = "Ноябрь";
i18n['months']['n12'] = "Декабрь";
i18n['months']['n2'] = "Февраль";
i18n['months']['n3'] = "Март";
i18n['months']['n4'] = "Апрель";
i18n['months']['n5'] = "Май";
i18n['months']['n6'] = "Июнь";
i18n['months']['n7'] = "Июль";
i18n['months']['n8'] = "Август";
i18n['months']['n9'] = "Сентябрь";
i18n['news'] = {};
i18n['news']['400_CII'] = "потому что такого комментария не существует";
i18n['news']['400_LII'] = "что-то пошло не так. Обновите страницу и попробуйте ещё раз";
i18n['news']['400_SII'] = "так как в адресе страницы есть недопустимые символы. Проверьте адрес, обновите страницу и попробуйте ещё раз";
i18n['news']['400_VFL'] = "так как некоторые поля, возможно, не заполнены или содержат недопустимые значения. Исправьте ошибку и попробуйте ещё раз";
i18n['news']['401_NAU'] = "так как вы не авторизованы. Пожалуйста, представьтесь системе и попробуйте ещё раз";
i18n['news']['403_CCI'] = "указан неверный код с картинки";
i18n['news']['403_PRO'] = "потому что автор отключил комментарии";
i18n['news']['403_UAC'] = "так как вы уже пожаловались. Это можно сделать только один раз";
i18n['news']['403_UBN'] = "потому что вас заблокировал модератор";
i18n['news']['403_UNM'] = "так как произошла ошибка доступа. Обновите страницу и попробуйте ещё раз";
i18n['news']['413_ETL'] = function(params) { return "так как в нем больше " + params["maxCommentSize"] + " знаков" };
i18n['news']['500_ISE'] = "что-то пошло не так. Подождите немного и попробуйте ещё раз";
i18n['news']['breadcrumb'] = "Главные новости";
i18n['news']['comments'] = "Комментарии";
i18n['news']['comments.add_error'] = function(params) { return "Не удалось отправить комментарий, " + params["reason"] + "." };
i18n['news']['comments.banned'] = "Вы не можете оставлять комментарии";
i18n['news']['comments.bound-phone'] = "Привязать номер";
i18n['news']['comments.bound-phone-text'] = "Чтобы опубликовать комментарий, нужно привязать к аккаунту номер телефона. Этого требует <a href=\"http://www.government.by/upload/docs/file944b1e7301d5a698.PDF\">законодательство Республики Беларусь.</a>";
i18n['news']['comments.complain_error'] = function(params) { return "Не удалось отправить жалобу на комментарий, " + params["reason"] + "." };
i18n['news']['comments.count'] = function(params) { return params["count"] + " " + dynamic.plural_adv({"count": "         " + params["count"] + "     ", "one": "комментарий", "some": "комментария", "many": "комментариев", "none": "комментариев"}) };
i18n['news']['comments.enter-url'] = "Введите адрес";
i18n['news']['comments.get_error'] = function(params) { return "Не удалось получить комментарии, " + params["reason"] + "." };
i18n['news']['comments.hint'] = "Чтобы изменить шрифт или добавить ссылку, выделите часть текста.";
i18n['news']['comments.load-captcha_error'] = function(params) { return "Не удалось получить каптчу, " + params["reason"] + "." };
i18n['news']['comments.non-authorized'] = "Авторизуйтесь, чтобы оставить комментарий";
i18n['news']['comments.pumpkin'] = "Комментирование невозможно, повторите позже";
i18n['news']['comments.removed'] = "Комментарий удалён";
i18n['news']['comments.send'] = "Отправить";
i18n['news']['comments.your-reply'] = "Ваш ответ";
i18n['news']['comments.your-word'] = "Ваше слово,";
i18n['news']['complaint'] = "Пожаловаться";
i18n['news']['complaint.question'] = "Пожаловаться на комментарий?";
i18n['news']['default_error'] = "что-то пошло не так. Попробуйте ещё раз чуть позже";
i18n['news']['edu.nav.list'] = "Перейти обратно к списку уроков";
i18n['news']['edu.nav.next'] = "Перейти к следующему уроку";
i18n['news']['filters.clear'] = "Сбросить фильтры";
i18n['news']['for_all_time'] = "За всё время";
i18n['news']['index.archive'] = "Новости";
i18n['news']['index.title'] = "Новости рекламных технологий";
i18n['news']['related.title'] = "Читайте похожие статьи";
i18n['news']['reply'] = "Ответить";
i18n['news']['tags'] = "Все темы";
i18n['offices'] = {};
i18n['offices']['readmore'] = "Подробнее";
i18n['order'] = {};
i18n['order']['agency'] = "Через рекламное агентство";
i18n['order']['chooseAgency'] = "Выбрать агентство";
i18n['order']['city'] = "город";
i18n['order']['country'] = "Страна";
i18n['order']['createAd'] = "Создать объявление";
i18n['order']['form'] = "С помощью менеджера Яндекса";
i18n['order']['personally'] = "Самостоятельно";
i18n['order']['pleaseSpecifyYourLocation'] = "Уточните, пожалуйста, ваше местоположение:";
i18n['order']['sendForm'] = "Отправить";
i18n['order']['title'] = "Разместить рекламу";
i18n['pages'] = {};
i18n['pages']['contact.description'] = "Офисы продаж и рекламные агентства";
i18n['pages']['contact.keywords'] = "Офисы продаж, Служба поддержки, Агентства";
i18n['pages']['contact.title'] = "Контакты — Яндекс.Реклама";
i18n['pages']['index.description'] = "";
i18n['pages']['index.keywords'] = "";
i18n['pages']['index.title'] = "Реклама на Яндексе — Яндекс.Реклама";
i18n['pages']['news.title'] = "Новости — Яндекс.Реклама";
i18n['pages']['order.title'] = "Разместить рекламу";
i18n['pages']['partners-news.title'] = "Новости закрытого раздела";
i18n['pages']['partners.title'] = "Рекламным агентствам";
i18n['pages']['requirements.title'] = "Требования к рекламным материалам";
i18n['pages']['subscription.partners.title'] = "Подписаться на новости Яндекса для рекламных агентств";
i18n['pages']['subscription.public.title'] = "Подписаться на новости рекламных технологий Яндекса";
i18n['partners'] = {};
i18n['partners']['button.back'] = "Назад";
i18n['partners']['button.next'] = "Далее";
i18n['partners']['button.send'] = "Отправить заявку";
i18n['partners']['followTheNews'] = "Следите за нашими новостями";
i18n['partners']['form.direct'] = "Рекламные продукты (Директ, Медийная реклама, Видеореклама, Справочник, Дзен)";
i18n['partners']['form.directAndMarket'] = "Рекламные продукты (Директ, Медийная реклама, Видеореклама, Справочник, Дзен) + Маркет";
i18n['partners']['form.disk.button'] = "Загрузить фид на Яндекс.Диск";
i18n['partners']['form.disk.modal.1'] = "Зайдите на <a href=\"https://disk.yandex.ru\" target=\"_blank\">Яндекс.Диск</a>  и нажмите кнопку «Загрузить». В появившемся окне выберите нужный фид.";
i18n['partners']['form.disk.modal.2'] = "После загрузки файла переведите переключатель в положение «Вкл» ― так вы создадите ссылку на ваш файл.\nСкопируйте ссылку и вставьте в окошко формы.";
i18n['partners']['form.disk.pseudolink'] = "Как загружать файлы на Яндекс.Диск";
i18n['partners']['form.emptyValue'] = "–";
i18n['partners']['form.error.email'] = "Некорректный email";
i18n['partners']['form.error.required'] = "Это поле обязательно для заполнения";
i18n['partners']['form.market'] = "Маркет";
i18n['partners']['form.tip'] = "Все поля обязательны для заполнения";
i18n['partners']['form.ty.contract'] = "Спасибо! \nМы обработаем заявку и свяжемся с вами в течение двух рабочих дней.";
i18n['partners']['form.ty.login'] = "Спасибо! \nМы обработаем заявку и свяжемся с вами в течение двух рабочих дней.";
i18n['partners']['form.ty.title'] = "Спасибо, Ваша заявка отправлена!";
i18n['partners']['goal.chooseGoal'] = "Выбрать цель";
i18n['partners']['goal.chooseGoal.text'] = "Напоминаем, что для заключения договора необходимо выполнять минимальные условия. Прочитать о них можно по <a href=\"/adv/partners\">ссылке</a>";
i18n['partners']['goal.contract'] = "Я хочу заключить договор, логин уже есть";
i18n['partners']['goal.contract.text'] = "Перед отправкой заявки необходимо зайти в систему под агентским логином, на котором находятся все ваши клиенты. Если такого логина нет — вам нужно выбрать цель «я хочу и логин, и договор».";
i18n['partners']['goal.login'] = "Я хочу агентский логин для доступа в интерфейс";
i18n['partners']['goal.login.direct.text'] = "Агентский интерфейс Директа разработан специально под нужды агентств: структура интерфейса позволит вам вести всех своих клиентов в одном месте, а вашим менеджерам — работать только с нужными логинами. Для получения доступа в интерфейс нет минимальных условий, достаточно быть агентством. Отправьте заявку, и мы свяжемся с вами в течение двух рабочих дней.";
i18n['partners']['goal.login.directAndMarket.text'] = "Агентский интерфейс разработан специально под нужды рекламных агентств: здесь можно вести всех клиентов агентства и управлять размещениями как в Директе, так и на Маркете. При этом каждый менеджер может работать только с нужными ему логинами. \nДля получения доступа в интерфейс нет специальных условий, достаточно быть агентством. Отправьте заявку, и мы свяжемся с вами в течение двух рабочих дней.";
i18n['partners']['goal.login.market.text'] = "Агентский интерфейс Маркета позволяет рекламным агентствам вести размещения всех своих клиентов в одном месте, при этом каждый менеджер может работать только с нужными ему логинами.\nДля получения доступа в интерфейс нет специальных условий, достаточно быть агентством. Отправьте заявку, и мы свяжемся с вами в течение двух рабочих дней";
i18n['partners']['menu.becomePartner'] = "Стать партнером";
i18n['partners']['products'] = "Какие еще продукты Яндекса могут заинтересовать ваших клиентов:";
i18n['partners']['step1'] = "Шаг 1. Общая информация";
i18n['partners']['step2'] = "Шаг 2. Цели агентства";
i18n['products'] = {};
i18n['products']['link'] = "Все цены";
i18n['products']['more'] = "Показать еще";
i18n['products']['more-detailed'] = "Подробнее";
i18n['products']['more.button'] = "Подробнее";
i18n['products']['order.button'] = "Заказать рекламу";
i18n['products']['targetings'] = "Виды таргетингов:";
i18n['products']['terms'] = "Полные условия по продукту";
i18n['search'] = {};
i18n['search']['0'] = "Новости";
i18n['search']['1'] = "Контекстная реклама";
i18n['search']['2'] = "Медийная реклама";
i18n['search']['3'] = "Мобильная реклама";
i18n['search']['4'] = "Классифайды";
i18n['search']['5'] = "Геореклама";
i18n['search']['6'] = "Кейсы и истории успеха";
i18n['search']['7'] = "Обучение";
i18n['search']['8'] = "Контакты";
i18n['search']['9'] = "Требования к рекламным материалам";
i18n['search']['all.pages'] = "Все страницы";
i18n['search']['find'] = "Найти";
i18n['search']['found'] = "Поиск по запросу";
i18n['search']['materials'] = "Материалы";
i18n['search']['not.found'] = "По вашему запросу ничего не найдено.";
i18n['search']['partners'] = "Партнёры";
i18n['search']['search'] = "Поиск";
i18n['search']['site.search'] = "Поиск по сайту";
i18n['search']['switch.left'] = "← + Alt";
i18n['search']['switch.right'] = "Alt + →";
i18n['sections'] = {};
i18n['sections']['analytics'] = "Аналитика";
i18n['sections']['contact'] = "Контакты";
i18n['sections']['distribution'] = "Дистрибуция";
i18n['sections']['edu.events'] = "Рекомендуем посетить";
i18n['sections']['edu.experts'] = "Партнёры по обучению";
i18n['sections']['education'] = "Обучение";
i18n['sections']['index'] = "Главная";
i18n['sections']['monetization'] = "Монетизация";
i18n['sections']['news'] = "Новости рекламы на Яндексе";
i18n['sections']['order'] = "Разместить рекламу";
i18n['sections']['partners'] = "Рекламным агентствам";
i18n['sections']['publishers'] = "Издателям";
i18n['sections']['requirements'] = "Требования к рекламным материалам";
i18n['sections']['subscription.partners'] = "Подписаться на новости для рекламных агентств";
i18n['sections']['subscription.public'] = "Подписаться на новости рекламных технологий";
i18n['sections']['subscription.publishers'] = "Подписаться на новости о технологиях монетизации для владельцев сайтов и мобильных приложений";
i18n['sections']['subscription.subs'] = "Подписаться на новости рекламных технологий";
i18n['solutions'] = {};
i18n['solutions']['analytics'] = "Аналитика";
i18n['solutions']['cases'] = "Кейсы";
i18n['solutions']['city'] = "Город";
i18n['solutions']['clear'] = "Сбросить";
i18n['solutions']['companySize'] = "Размер компании";
i18n['solutions']['error'] = "Не удалось загрузить решения. Попробуйте позже";
i18n['solutions']['industries'] = "Отрасли";
i18n['solutions']['products'] = "Продукты";
i18n['solutions']['read.more'] = "Подробнее";
i18n['solutions']['registration.year'] = "Дата основания";
i18n['solutions']['site'] = "Сайт";
i18n['solutions']['stories'] = "Истории успеха";
i18n['solutions']['tasks'] = "Задачи";
i18n['solutions']['yandex.year'] = "Пришли на Яндекс";
i18n['support'] = {};
i18n['support']['feedback.form'] = "Отправить письмо";
i18n['support']['feedback.link'] = "Форма обратной связи";

export default i18n;